// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import _ from 'lodash';
import OlOverlay from 'ol/overlay';
import OlSourceVector from 'ol/source/vector';
import OlLayerVector from 'ol/layer/vector';
import OlStyleStyle from 'ol/style/style';
import OlStyleStroke from 'ol/style/stroke';
import OlFormatWKT from 'ol/format/wkt';
import Marker from './DroneMarker';
import { loadVideoTrack, setSelectedVideoIndex} from '../../../../actions/video';
import { setDroneLocation } from '../../../../actions/map';
import { getSelectInteractionManager } from '../../../../utilities/selectInteractionManager';

const VIDEOS_LAYER_NAME = 'Videos';

export class VideoLayer extends React.Component {
    marker = null;
    videoSource = null;
    displayedFeatures = [];

    constructor(props) {
        super(props);

        this.marker = new OlOverlay({
            stopEvent: false
        });
        this.marker.setPosition(undefined);
        this.marker.setPositioning('center-center');
        props.olMap.addOverlay(this.marker);

        this.videoSource = new OlSourceVector();
        const videoLayer = new OlLayerVector({
            source: this.videoSource,
            showInLegend: true,
            visible: true,
            zIndex: 1000001,
            name: VIDEOS_LAYER_NAME,
            style: new OlStyleStyle({
                stroke: new OlStyleStroke({
                    color: '#f1c40f',
                    width: 3
                })                
            })
        });
        props.olMap.addLayer(videoLayer);
        this.addVideoSelectFeatureInteractionon();
    }

    addVideoSelectFeatureInteractionon() {
        const selectConfig = {
            style: new OlStyleStyle({
                stroke: new OlStyleStroke({
                    color: '#2edcd2',
                    width: 4
                })
            }),
            idColumnName: 'id',
            layerName: VIDEOS_LAYER_NAME,
            onFeatureSelect: this.onVideoFeatureSelect.bind(this),
        };
        getSelectInteractionManager('map').addSelectConfig(selectConfig);
    }

    onVideoFeatureSelect(id) {
        const { setDroneLocation, setSelectedVideoIndex, videoDetails } = this.props;
        const index = videoDetails.findIndex(video => video.id === id);
        setSelectedVideoIndex(index !== -1 ? index : null);
        setDroneLocation(null);
    }

    selectVideoFeature() {
        const { selectedVideoIndex, videoDetails } = this.props;

        if (selectedVideoIndex !== null) {
            const selectedFeature = this.displayedFeatures.find(feature => {
                return feature.get('id') === videoDetails[selectedVideoIndex].id;
            });
            getSelectInteractionManager('map').selectFeature(VIDEOS_LAYER_NAME, selectedFeature);
        } else {
            getSelectInteractionManager('map').selectFeature(VIDEOS_LAYER_NAME, null);
        }
    }

    updateVideoFeatures() {
        const { videoDetails } = this.props;
        this.videoSource.clear();
        if (!videoDetails) return;

        this.displayedFeatures = videoDetails
            .filter(video => video.geomWkt)
            .map(video => {
                const format = new OlFormatWKT();
                const feature = format.readFeature(video.geomWkt);
                feature.set('id', video.id);
                feature.set('layerName', VIDEOS_LAYER_NAME);
                this.videoSource.addFeature(feature);
                return feature;
            });
    }

    componentDidUpdate(prevProps) {
        const { axiosInstance, videoDetails, selectedVideoIndex, loadVideoTrack } = this.props;

        if (!_.isEqual(prevProps.videoDetails, videoDetails)) {            
            this.updateVideoFeatures();            
        }
        if (!_.isEqual(prevProps.videoDetails, videoDetails) || prevProps.selectedVideoIndex !== selectedVideoIndex) {
            if (selectedVideoIndex !== null && videoDetails.length > 0) {
                const videoDetail = videoDetails[selectedVideoIndex];
                if (videoDetail) loadVideoTrack(axiosInstance, videoDetail.id);
            }
            this.selectVideoFeature();
        }
    }

    render() {
        const { droneLocation, selected } = this.props
        if (droneLocation) {
            return (
                <div>
                    <Marker location={this.props.droneLocation} marker={this.marker} visible={selected === "video"} />
                    {/*<InfoPanel longitude={this.props.droneLongitude} latitude={this.props.droneLatitude} ascent={this.props.droneAscent} dateTime={this.props.droneDateTime} />*/}
                </div>
            );
        }

        return (null);
    }
};

const mapStateToProps = state => ({
    droneLocation: state.mapData.get('droneLocation'),
    videoDetails: state.video.get('videos'),
    selectedVideoIndex: state.video.get('selectedVideoIndex'),
    axiosInstance: state.auth.get('axiosInstance'),
    selected: state.modules.get('selected')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    setSelectedVideoIndex,
    setDroneLocation, 
    loadVideoTrack
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VideoLayer)


// WEBPACK FOOTER //
// ./src/containers/content/map/videos/VideoLayer.jsx